export default __webpack_public_path__ + "static/media/completed-tick-icon.bd00f01e.svg";